import './SiteAdminView.scss';

import SiteAdminView from './SiteAdminView';

export default SiteAdminView;
